import React from 'react';

import {ARTIFACT_VERSION_PATH} from '../artifacts/artifactPaths';
import {type RouteData} from '../types';
import {REGISTRY_PATHS} from './registryPaths';

export const REGISTRY_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Registries',
    },
    exact: true,
    isPrivateRoute: false,
    path: REGISTRY_PATHS,
    RouteComponent: React.lazy(
      () => import('../../components/Registries/RegistriesRouter')
    ),
  },
  {
    path: `${ARTIFACT_VERSION_PATH}/graph`,
    redirect: `${ARTIFACT_VERSION_PATH}/lineage`,
  },
  {
    path: '/models',
    redirect: '/registry/model',
  },
];
